import { createFileRoute } from "@tanstack/react-router";

import { ErrorBoundary } from "@vendor-app/app/_sharedComponents/ErrorBoundary";
import { LoginPage } from "@vendor-app/app/_sharedComponents/LoginPage";

export const Route = createFileRoute("/login/")({
  component: Index,
  errorComponent: ({ error, info }) => <ErrorBoundary error={error} info={info} />,
});

function Index() {
  return <LoginPage />;
}
